<template>
  <div class="app">
    <div class="moments__post" v-for="(item, index) in list" :key="index">
      <div class="post-left">
        <img v-if="item.tx" class="post_header" :src="item.tx" />
        <img v-else class="post_header" src="@images/headerDft.png" />
      </div>

      <div class="post_right">
        <span class="post-username">{{ item.xm }}</span>
        <div class="paragraph">{{ item.content || '' }}</div>
        <!-- 相册 -->
        <div class="thumbnails" v-if="item.imgUrl">
          <div
            :class="item.imgUrl.split(',').length == 1 ? 'my-gallery' : 'thumbnail'"
            v-for="(image, index_images) in item.imgUrl.split(',')"
            :key="index_images"
          >
            <img
              class="gallery_img"
              lazy-load
              mode="aspectFill"
              :src="image"
              :data-src="image"
              @click="previewImage(item.imgUrl.split(','), index_images)"
            />
          </div>
        </div>
        <!-- 资料条 -->
        <div class="toolbar">
          <div class="time">{{ item.createTime }}
           <img v-if="item.createBy==createBy" src="@images/gzfw/delete.png" @click="clickDelete(item,index)"  style="margin-left:4px;width:14px;height:14px"/> 
          </div>
          <div class="like" @click="like(index, item)">
            <img v-if="item.sfdz == 'n'"  src="@images/gzfw/islike.png"/>
            <img v-else src="@images/gzfw/like.png"/>
          </div>
          <div class="comment" @click="comment(index)">
            <img src="@images/gzfw/comment.png"/>
          </div>
        </div>
        <!-- 赞／评论区 -->
        <div v-if="item.dzr || item.plList.length > 0" class="post-footer">
          <div v-if="item.dzr" class="footer_content" style="padding: 20rpx">
            <img class="liked" src="@images/gzfw/liked.png" />
            <span class="nickname" style="margin-right: 10rpx">{{ item.dzr }}</span>
          </div>
          <div
            style="padding-bottom: 20rpx"
            class="footer_content"
            v-for="(comment, comment_index) in item.plList"
            :key="comment_index"
            @click="reply(index, comment_index)"
          >
            <span class="comment-nickname">
              {{ getHfname(comment) }}:
              <span class="comment-content">{{ comment.content }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
     <van-popup v-model="show" position="bottom" :style="{ height: '60px' }">
      <div class="bottom-pl">
         <input class="input" v-model="message" :placeholder="input_placeholder"/>
         <span class="btn" @click="send_comment">评论</span>
      </div>
    </van-popup>
  </div>
</template>



<script>
import { ImagePreview } from 'vant'
import { Dialog } from 'vant'
import Vue from 'vue'
import { OPEN_ID, SYS_ORGCODE, WX_USER, ACCESS_TOKEN, APPID } from '@/store/mutation-types'
import { deleteAction, postAction } from '@/api/manage'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
     realname:{
      type:String,
      default:'',
    },
     isDel:{
      type:Boolean,
      default:false,
    }  
  },
  data() {
    return {
      listData: [],
      show: false,
      obj: {},
      input_placeholder:'',
      message:'',
      is_reply:false,
      createBy:'',
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {
   let userInfo = Vue.ls.get(WX_USER, {})
   this.createBy = userInfo.username;

  },
  methods: {
    getHfname(item) {
      let name = ''
      if (item.bhfrId) {
        name = item.hfrId_dictText + '回复' + item.bhfrId_dictText
      } else {
        name = item.hfrId_dictText
      }
      return name
    },
    like(index,item){
        console.log(this.realname);
       if (item.sfdz == 'n') {
        this.addLike(index, item);
      } else {
        this.cancelLike(index, item);
      }
    },
     addLike(index, item) {
      var params = {
        workMomentsId: item.id,
        dzrName: this.realname
      };
      console.log(this.realname);
      postAction('/zhshj/workmomentsdz/add/wswx', params).then(res => {
        if (res.success) {
          let message = res.message;
          this.list[index].dzr = message;
          this.list[index].sfdz = 'y';
        } else {
          this.$toast('请求超时');
        }
      });
    },
    cancelLike(index, item) {
      let url = `/zhshj/workmomentsdz/qxdz/wswx?workMomentsId=${item.id}`;
      deleteAction(url).then(res => {
        if (res.success) {
          let message = res.message;
          this.list[index].dzr = message;
          this.list[index].sfdz = 'n';
        } else {
          this.$toast('请求超时');
        }
      });
    },
    previewImage(imgList,index) {
          ImagePreview({
            images: imgList,
            startPosition: index,
          })
      },
    comment(index) {
      this.show = true; //调起input框
      this.input_placeholder='评论';
      this.index = index;
    },
    reply(index, comment_index) {
      this.is_reply = true; //回复中
      this.show = true; //调起input框
      let replyTo = this.list[index].plList[comment_index].hfrId_dictText;
      this.input_placeholder = '回复' + replyTo;
      this.index = index; //post索引
      this.comment_index = comment_index; //评论索引
      // this.focus = true;
    }, 
     send_comment() {
      if(this.message.trim()==''){
       return this.$toast('请输入内容')
      }
      var index = this.index;
      let item = this.list[index];
      let bplrId = '';
      if (this.is_reply) bplrId = item.plList[this.comment_index].hfrId;
      var params = {
        workMomentsId: item.id,
        content: this.message,
        bplrId: bplrId
      };

      postAction('/zhshj/workmomentspl/add/wswx', params).then(res => {
        if (res.success) {
          this.show = false;
          this.list[index].plList = res.result;
        }
        this.message= '';
      });
    },
    clickDelete(item,index){
     Dialog.confirm({
        title: '提示',
        message: '确认要删除这条记录吗？',
      })
        .then(() => {
          // on confirm
          this.deleteItem(item,index);
        })
        .catch(() => {
          // on cancel
        });
    },
    deleteItem(item,index){
     let url = `zhshj/gzfwwswx/delete?id=${item.id}`;
      deleteAction(url).then(res => {
        if (res.success) {
           this.listData.splice(index,1);
           this.$toast('删除成功')
        } else {
          this.$toast(res.message);
        }
      });
    }
  },
}
</script>

<style lang="less" >
.app {
  width: 100%;
  background-color: #f6f7f9;
}
* {
  box-sizing: border-box;
}
.moments__post {
  background: #fff;
  border-bottom: 1px solid #f2eeee;
  padding: 15px 10px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  width: 100%;

  .post-left {
    .post_header {
      width: 45px !important;
      height: 45px !important;
      border-radius: 5px;
      margin-top: 4px;
    }
  }

  .post_right {
    font-size: 16px;
    display: table-cell;
    padding-left: 10px;
    flex: 1;

    .paragraph {
      font-size: 14px;
      padding: 5px;
    }

    .thumbnails {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .thumbnail {
        width: 30%;
        height: 90px;
        margin: 2px;
        background: #757575;
        overflow: hidden;
      }

      .my-gallery {
        width: 125px;
        height: 200px;
        margin: 2px;
        background: #757575;
        overflow: hidden;
      }

      .gallery_img {
        width: 100%;
        height: 100%;
      }

    }

     .toolbar {
        position: relative;
        display: flex;
        align-items: center;
        padding: 10px 0;

         .like {
          width: auto;
          height: auto;
          position: absolute;
          right: 30px;
          display: flex;
          align-items: center;
        }

        .comment {
          width: auto;
          height: auto;
          position: absolute;
          right: 0px;
          display: flex;
          align-items: center;
        }
        img {
          margin-left: 10px;
          width: 20px;
          height: 20px;
        }
      }
    
  }
}
.time {
  color: #36648b;
  margin-top: 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.post-footer{
	margin-top: 15px;
	background-color: #f3f3f5;
	width: 100%;
}
.footer_content {
  padding: 6px 5px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;

  .nickname {
    color: #36648b;
    font-size: 12px;
  }

  .comment-nickname {
    color: #36648b;
    font-size: 12px;
  }

  .comment-content {
    color: #000000;
    font-size: 12px;
  }
  .liked{
	position: relative;
	margin-right: 5px;
	width: 18px;
	height: 18px;
}
}

.bottom-pl{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background: #F5F6F7;
  .btn{
   background: #2979ff;
   display: inline-block;
   padding: 4px 6px;
   color: #FFF;
   font-size: 15PX;
   margin-left: 10px;
   border-radius: 4px;
  }
  .input{
    flex: 1;
    border: none;
    background: #fff;
    border-radius: 4px;
    padding-left: 4px;
    height: 40px;
    line-height: 40px;
  }
}
</style>
